// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GcpGkeAutoscalingProfile } from './GcpGkeAutoscalingProfile';
import {
  GcpGkeAutoscalingProfileFromJSON,
  GcpGkeAutoscalingProfileFromJSONTyped,
  GcpGkeAutoscalingProfileToJSON,
  GcpGkeAutoscalingProfileToJSONTyped,
} from './GcpGkeAutoscalingProfile';
import type { GcpGkeNodePool } from './GcpGkeNodePool';
import {
  GcpGkeNodePoolFromJSON,
  GcpGkeNodePoolFromJSONTyped,
  GcpGkeNodePoolToJSON,
  GcpGkeNodePoolToJSONTyped,
} from './GcpGkeNodePool';
import type { GcpGkeNetworkProviderType } from './GcpGkeNetworkProviderType';
import {
  GcpGkeNetworkProviderTypeFromJSON,
  GcpGkeNetworkProviderTypeFromJSONTyped,
  GcpGkeNetworkProviderTypeToJSON,
  GcpGkeNetworkProviderTypeToJSONTyped,
} from './GcpGkeNetworkProviderType';

/**
 *
 * @export
 * @interface GcpGke
 */
export interface GcpGke {
  /**
   *
   * @type {GcpGkeAutoscalingProfile}
   * @memberof GcpGke
   */
  autoscalingProfile?: GcpGkeAutoscalingProfile;
  /**
   *
   * @type {Array<string>}
   * @memberof GcpGke
   */
  masterVersions?: Array<string>;
  /**
   *
   * @type {GcpGkeNetworkProviderType}
   * @memberof GcpGke
   */
  networkProvider?: GcpGkeNetworkProviderType;
  /**
   *
   * @type {Array<GcpGkeNodePool>}
   * @memberof GcpGke
   */
  nodePools?: Array<GcpGkeNodePool>;
  /**
   *
   * @type {Array<string>}
   * @memberof GcpGke
   */
  zones?: Array<string>;
}

/**
 * Check if a given object implements the GcpGke interface.
 */
export function instanceOfGcpGke(value: object): value is GcpGke {
  return true;
}

export function GcpGkeFromJSON(json: any): GcpGke {
  return GcpGkeFromJSONTyped(json, false);
}

export function GcpGkeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpGke {
  if (json == null) {
    return json;
  }
  return {
    autoscalingProfile:
      json['autoscaling_profile'] == null
        ? undefined
        : GcpGkeAutoscalingProfileFromJSON(json['autoscaling_profile']),
    masterVersions:
      json['master_versions'] == null ? undefined : json['master_versions'],
    networkProvider:
      json['network_provider'] == null
        ? undefined
        : GcpGkeNetworkProviderTypeFromJSON(json['network_provider']),
    nodePools:
      json['node_pools'] == null
        ? undefined
        : (json['node_pools'] as Array<any>).map(GcpGkeNodePoolFromJSON),
    zones: json['zones'] == null ? undefined : json['zones'],
  };
}

export function GcpGkeToJSON(json: any): GcpGke {
  return GcpGkeToJSONTyped(json, false);
}

export function GcpGkeToJSONTyped(
  value?: GcpGke | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    autoscaling_profile: GcpGkeAutoscalingProfileToJSON(
      value['autoscalingProfile'],
    ),
    master_versions: value['masterVersions'],
    network_provider: GcpGkeNetworkProviderTypeToJSON(value['networkProvider']),
    node_pools:
      value['nodePools'] == null
        ? undefined
        : (value['nodePools'] as Array<any>).map(GcpGkeNodePoolToJSON),
    zones: value['zones'],
  };
}
